import { ModelInstance, BaseModel, ToFrontHook, ToBackHook } from './util';
import { Recording } from './recording';

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    token: 'token',
    league_id: 'leagueId',
    live_recording: 'liveRecording',
  },
  relation: {
    liveRecording: Recording
  }
})
export class Camera extends BaseModel {
  id: number;
  name: string;
  token: string;
  leagueId: number;
  liveRecording: Recording;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
